module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "dixie1"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "toc-anchor"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override"
  }, [_c('span', {
    staticClass: "no-style-override5"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("Lots of people were instrumental in helping me recreate and comprise the factual events involved with the Dixie Shanahan murder case.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("First, special praise goes out to WildBlue Press co-founders Steve Jackson and Michael Cordova, for launching a true-crime book publishing company that is like no other publishing firm. Special recognition also goes to book designer Elijah Toten and copy editor Jenni Grubbs for their outstanding hard work and careful attention to detail during the final stages of production for DIXIE’S LAST STAND.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("Along those lines, I would like to extend a special thanks to those of you who are devoted and faithful readers of true-crime. I know I speak for the other authors at WildBlue Press in offering my sincerest gratitude and deepest appreciation for those of you who take the time to read our books. Without you, there simply would be no reason to research and produce our books.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("In addition, I would like to single out true-crime author RJ Parker for truly going above the call of duty to help promote DIXIE’S LAST STAND amongst RJ’s army of true-crime followers across the world. If you are not reading a true-crime book published by WildBlue Press, please consider reading one of the many fine true-crime books authored by RJ Parker, including one of his latest, “Serial Killer Groupies.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("Others who were instrumental in the production and presentation of DIXIE’S LAST STAND:")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("Terry O’Grady, a courts reporter in Iowa, was responsible for transcribing the entire court proceedings regarding the case involving Dixie Shanahan. Many of the direct quotations that were used in this true-crime book were contained within the official court transcripts taken during State v. Dixie Lynn Shanahan as transcribed by O’Grady. These quotations took place during Dixie Shanahan’s pretrial motion hearings, during her jury trial or at her sentencing hearing. Other direct quotations contained within the book were derived from a number of interviews that I conducted with key persons. There were a few occasions where I included direct quotations from past newspaper articles that I had written for the Omaha World-Herald; others are duly noted within the book as coming from various news media outlets.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("Carol Hunter, executive news editor at the Des Moines Register, graciously took the time to furnish me with access to several high-quality photos contained within the Des Moines Register’s archives. Carol actually hired me")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("—")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("and my future wife, Andrea")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("—")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("back in 2000 when she was the executive editor of the Green Bay Press-Gazette in Wisconsin. Carol also attended our wedding two years later. I left the Green Bay paper in late 2003 to become a journalist in Omaha, and within a few years Carol moved over to the Des Moines Register to become an editor there. These days, our family is back in Wisconsin. I work out of the Post-Crescent in Appleton as the investigative team editor for Gannett Wisconsin Media.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("Bob Bjoin, managing editor of the Harlan Iowa Newspapers, provided access to several of his newspaper’s high-quality archived photographs to republish for DIXIE’S LAST STAND. Just like the Register, the Harlan Newspapers also provided excellent news coverage for its readers in covering the murder case involving Dixie Shanahan.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("Fred Scaletta, assistant director of Iowa Department of Corrections, was diligent and extremely helpful in facilitating my requests for public information related to Dixie Shanahan.")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("Also, a special thank-you to: retired Shelby County Sheriff Gene Cavenaugh and his successor, Sheriff Mark Hervey; Joe Jordan, managing editor of Nebraska Watchdog; Charles Thoman, retired assistant attorney general for the State of Iowa; and now-retired Iowa District Judge Charles Smith III for taking the time to allow me to interview them. Their first-hand insight was invaluable.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("My wonderful wife, Andrea, who has developed quite a knack for coming up with the clever true-crime book titles. Andrea suggested the title of DIXIE’S LAST STAND for this true-crime feature. When her proposed title was crowd-sourced by WildBlue Press with four other possible book titles, readers chose her title by overwhelming fashion. (She also came up with the title for my first book, which came out in June 2014, BLOODY LIES: A CSI SCANDAL IN THE HEARTLAND.)")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-241-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override6"
  }, [_vm._v("DIXIE’S LAST STAND: WAS IT MURDER OR SELF-DEFENSE?")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override4"
  }, [_vm._v("Is dedicated to those small-town law enforcement investigators who vigorously pursue the truth and justice even when constrained by circumstances and very limited resources.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override8"
  }, [_c('br', {
    staticClass: "calibre4"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_6"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5713f19c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Acknowledgments.vue
// module id = 69
// module chunks = 0